import React from "react";
import Header from "../components/Header";

const CompanyView = ({ LeftNavRef }) => {
  return (
    <div className="w-full px-4 md:px-10 pb-10">
      <Header LeftNavRef={LeftNavRef} />
      <h1 className="hidden sm:block text-lg font-normal p-5">
        Company Profile Overview
      </h1>

      <div className="flex flex-wrap lg:flex-nowrap justify-start lg:justify-between lg:space-x-5 w-full">
        <div className="w-full sm:w-6/12 lg:w-4/12">
          <div className="bg-gray-100 p-3 m-3 flex flex-col shadow-2xl min-h-[360px]">
            <div className="flex items-center justify-start space-x-3">
              <div className="w-8 h-8 bg-gray-400 rounded-full"></div>
              <h2 className="text-lg text-gray-900">Company Profile</h2>
            </div>
            <div className="w-full flex justify-between mt-2 mb-3">
              <hr style={{ height: "3.5px" }} className="w-6/12 bg-gray-400" />
              <hr style={{ height: "3.5px" }} className="w-6/12 bg-gray-200" />
            </div>

            <div className="space-y-3">
              <p className="w-full flex justify-between items-center py-1.5 px-4 text-xl rounded text-white  pink-btn  ">
                Overview
              </p>
            </div>
          </div>
        </div>

        <div className="w-full sm:w-6/12 lg:w-4/12">
          <div className="bg-gray-100 p-3 m-3 flex flex-col shadow-2xl min-h-[360px]">
            <h2 className="text-lg text-gray-900 opacity-0">
              Employees CompanyView
            </h2>
            <div className="w-full flex justify-between mt-2 mb-3">
              <hr style={{ height: "3.5px" }} className="w-6/12 bg-gray-400" />
              <hr style={{ height: "3.5px" }} className="w-6/12 bg-gray-200" />
            </div>

            <div className="space-y-3">
              <button className="w-full flex justify-between items-center py-1.5 px-4 text-xl rounded text-white  pink-btn  ">
                <span className="text-base">Active</span>
                <span className="text-sm">18</span>
              </button>
              <button className="w-full flex justify-between items-center py-1.5 px-4 text-xl rounded text-white  pink-btn  ">
                <span className="text-base">Onboarding</span>
                <span className="text-sm">20</span>
              </button>
              <button className="w-full flex justify-between items-center py-1.5 px-4 text-xl rounded text-white  pink-btn  ">
                <span className="text-base">Location</span>
                <span className="text-sm">3</span>
              </button>
            </div>

            <div className="flex justify-between mt-5">
              <div className="w-4/12 text-center">
                <h2 className="text-sm text-green-700 font-medium">AMERICA</h2>
                <small>New York</small>
              </div>
              <div className="w-4/12 text-center border-l-2 border-r-2">
                <h2 className="text-sm text-green-700 font-medium">EUROPE</h2>
                <small>LISBON</small>
              </div>
              <div className="w-4/12 text-center">
                <h2 className="text-sm text-green-700 font-medium">ASIA</h2>
                <small>SINGAPORE</small>
              </div>
            </div>
          </div>
        </div>

        <div className="w-full sm:w-6/12 lg:w-4/12">
          <div className="bg-gray-100 p-3 m-3 flex flex-col shadow-2xl min-h-[360px]">
            <h2 className="text-lg text-gray-900 opacity-0">
              Spent By Company
            </h2>
            <div className="w-full flex justify-between mt-2 mb-3 opacity-0">
              <hr style={{ height: "3.5px" }} className="w-6/12 bg-gray-400" />
              <hr style={{ height: "3.5px" }} className="w-6/12 bg-gray-200" />
            </div>

            <div className="space-y-3">
              <div>
                <p className="w-full py-1.5 px-4 text-base rounded text-white  pink-btn  ">
                  Total Payroll
                </p>
                <p className="flex justify-between px-1 sm:px-4">
                  <span>Total spent</span>
                  <span>324,135,3€</span>
                </p>
              </div>
              <div>
                <p className="w-full py-1.5 px-4 text-base rounded text-white  pink-btn  ">
                  Total Employee Cost
                </p>
                <p className="flex justify-between px-1 sm:px-4">
                  <span>Total spent</span>
                  <span>324,135,3€</span>
                </p>
              </div>
              <div>
                <p className="w-full py-1.5 px-4 text-base rounded text-white  pink-btn  ">
                  Agile Gross profit
                </p>
                <p className="flex justify-between px-1 sm:px-4">
                  <span>Total spent</span>
                  <span>324,135,3€</span>
                </p>
              </div>
              <div>
                <p className="w-full py-1.5 px-4 text-base rounded text-white  pink-btn  ">
                  Others
                </p>
                <p className="flex justify-between px-1 sm:px-4">
                  <span>Total spent </span>
                  <span>324,135,3€</span>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CompanyView;
